/*
TODO
[ ] - dismiss timer

* */
import React, {Component} from 'react';
import PropTypes from "prop-types";
import TransitionGroup from 'react-transition-group/TransitionGroup';
import emitter from '../eventEmitter'

import NotificationEvent from "./NotificationEvent";
import NotificationType from "./NotificationType";
import FadeTransition from '../transitions/FadeTransition';


const POPUP_DURATION = 10000;

class NotificationManager extends Component {
  constructor(props){
    super(props);
    this.state = {
      popups: [],
      alert: undefined
    };
    this.onAddNotification = this.onAddNotification.bind(this);
    this.onRemoveNotification = this.onRemoveNotification.bind(this);
    this.addPopup = this.addPopup.bind(this);
    this.removePopup = this.removePopup.bind(this);
    this.addAlert = this.addAlert.bind(this);
    this.removeAlert = this.removeAlert.bind(this);

  }

  componentWillMount() {
    emitter.on(NotificationEvent.ADD_NOTIFICATION, this.onAddNotification);
    emitter.on(NotificationEvent.REMOVE_NOTIFICATION, this.onRemoveNotification);
  }

  componentWillUnmount() {
    emitter.removeListener(NotificationEvent.ADD_NOTIFICATION, this.onAddNotification);
    emitter.removeListener(NotificationEvent.REMOVE_NOTIFICATION, this.onRemoveNotification);
  }

  onAddNotification(event){
    switch(event.type){
      case NotificationType.POPUP:
        this.addPopup(event.data);
        break;
      case NotificationType.ALERT:
        this.addAlert(event.data);
        break;
    }
  }
  onRemoveNotification(event){
    switch (event.type){
      case NotificationType.POPUP:
        this.removePopup();
        break;
      case NotificationType.ALERT:
        this.removeAlert();
        break;
    }
  }
  addPopup(popup){
    const popups = [...this.state.popups];

    let notificationTransition = (
      <FadeTransition duration={150} key={+new Date}>
        {popup}
      </FadeTransition>
    );
    popups.push(notificationTransition);
    const popupTimer = this.startPopupTimer();
    this.setState({ popups, popupTimer })
  }

  removePopup(){
    let { popupTimer } = this.state;
    clearTimeout(popupTimer);
    const popups = [...this.state.popups];
    if(popups.length){
      popups.splice(0,1);
      if(popups.length) popupTimer = this.startPopupTimer();
      this.setState({ popups, popupTimer });
    }
  }

  startPopupTimer() {
    return setTimeout(this.removePopup, POPUP_DURATION);
  }

  addAlert(a){
    let alert = (
      <FadeTransition duration={150} key={+new Date}>
        {a}
      </FadeTransition>
    );
    this.setState({ alert });
  }

  removeAlert() {
    this.setState({ alert: undefined })
  }

  render(){
    const {popups, alert} = this.state;
    let notification;
    if(popups){
      notification = popups[0];
    }
    return(
      <div className="cm-notifications">
        <TransitionGroup>
        {notification}
        {alert}
        </TransitionGroup>
      </div>
    );
  }
}



export default NotificationManager;
